import { createLowlight, common } from "lowlight";
import { CodeBlockLowlight as BaseCodeBlockLowlight } from "@tiptap/extension-code-block-lowlight";

// some browser does not have `.hasOwn`. this would polyfill it
const bindHasOwn = () => {
    if ("hasOwn" in Object) {
        return;
    } else {
        Object.hasOwn = Object.call.bind(Object.hasOwnProperty);
    }
};

bindHasOwn();

const lowlight = createLowlight(common);

export const CodeBlockLowlight = BaseCodeBlockLowlight.extend({
    addOptions() {
        return {
            ...this.parent?.(),
            lowlight,
        };
    },
    addKeyboardShortcuts() {
        return {
            ...this.parent?.(),
            Tab: () => {
                if (this.editor.isActive("codeBlock")) {
                    this.editor.commands.insertContent("\t");
                    return true;
                }

                return false;
            },

            "Shift-Tab": () => {
                if (this.editor.isActive("codeBlock")) {
                    const state = this.editor.state;
                    const { selection } = state;
                    const { $from } = selection;

                    const pos = $from.pos;
                    let endlineEndPos = pos;
                    let endlineStartPos = pos;

                    // find initial "\n" at current line
                    for (let max = 0; max < 1000; max++, endlineStartPos--) {
                        const char = state.doc.textBetween(endlineStartPos, pos);
                        if (char.includes("\n")) {
                            endlineStartPos = endlineStartPos + 1;
                            break;
                        }
                    }

                    // find initial "\n" at the end of current line
                    for (let max = 0; max < 1000; max++, endlineEndPos++) {
                        const char = state.doc.textBetween(pos, endlineEndPos + 1);
                        if (char.includes("\n")) {
                            break;
                        }
                    }

                    let selectedText = this.editor.state.doc.textBetween(endlineStartPos, endlineEndPos);

                    if (selectedText.startsWith("\t")) {
                        selectedText = selectedText.substring(1);
                    } else if (selectedText.startsWith("    ")) {
                        selectedText = selectedText.substring(4);
                    } else {
                        return true;
                    }

                    this.editor.commands.setTextSelection({ from: endlineStartPos, to: endlineEndPos });
                    this.editor.commands.insertContent(selectedText);

                    return true;
                }

                return false;
            },

            "Mod-a": () => {
                if (this.editor.isActive("codeBlock")) {
                    const { doc, selection } = this.editor.state;
                    const $from = doc.resolve(selection.from);
                    const block = $from.node($from.depth);

                    if (block.type.name === "codeBlock") {
                        const from = $from.start($from.depth);
                        const to = $from.end($from.depth);

                        if (selection.from === from && selection.to === to) {
                            this.editor.commands.selectAll();
                        } else {
                            this.editor.commands.setTextSelection({ from, to });
                        }
                        return true;
                    }
                }
                return false;
            },
        };
    },
});
